import React from "react";
import { Swiper } from "swiper/react";

function CreatorArtistSkeleton({}: any) {
  const arr = [1, 2, 3, 4, 5, 6];
  return (
    <div className="mt-10">
      <div className="flex flex-row justify-between">
        <div className="w-[350px] h-[30px] bg-[#1a1919] rounded-lg"></div>
        <div className="w-[100px] h-[30px] mr-[50px] bg-[#1a1919] rounded-lg"></div>
      </div>
      <div className="">
        <Swiper
          slidesPerView={6}
          breakpoints={{
            0: {
              slidesPerView: 2,
            },
            350: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 4,
            },
            1300: {
              slidesPerView: 6,
            },
            1500: {
              slidesPerView: 7,
            },
          }}
          className="mySwiper mx-auto mt-5 mb-5 w-full"
        >
          <div className="flex flex-row lg:gap-[60px] sm:gap-[20px] gap-3">
            {arr.map((item: any) => (
              <div
                key={item}
                className="flex flex-col justify-center items-start"
              >
                <div className="w-[130px] h-[130px] rounded-full bg-[#1a1919] animate-pulse mt-2 "></div>
                <div className="w-[100px] mt-5 h-[30px] mr-[50px] bg-[#1a1919] ml-3 rounded-lg"></div>
              </div>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
}

export default CreatorArtistSkeleton;
